import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function V2ThankYouSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-center items-center h-full text-center">
      <SlideWaveBackground />
      <div className="relative z-10">
        <h2 className="text-[80px] font-light tracking-tight leading-none font-[family-name:var(--font-heading)] mb-6">
          Thank you
        </h2>
        <div className="flex items-center justify-center gap-3 text-[14px] font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)]">
          <span className="font-medium text-[var(--color-fg)]">Ben Zhang</span>
          <span className="text-[var(--color-border)]">·</span>
          <a href="mailto:ben@cosx.co" className="hover:text-[var(--color-accent)] transition-colors">ben@cosx.co</a>
          <span className="text-[var(--color-border)]">·</span>
          <a href="https://cosx.co" target="_blank" rel="noopener noreferrer" className="text-[var(--color-accent)] hover:opacity-80 transition-opacity">cosx.co</a>
        </div>
      </div>
    </div>
  );
}
